import React from "react";
import { Link } from "react-router-dom";

const LineupHelp = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <Link to="/help" className="text-deep-red hover:text-bright-red">
          &larr; Back to Help Center
        </Link>
      </div>
      <h1 className="text-3xl font-bold text-dark-grey mb-6">Lineup Help</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Creating Your Lineup</h2>
          <p className="text-medium-grey">
            A lineup is your selection of fighters for an upcoming event. Creating a strong lineup is key to scoring points and winning in your leagues.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Fighter Selection</h2>
          <p className="text-medium-grey mb-4">
            When selecting fighters for your lineup, consider these factors:
          </p>
          <ul className="list-disc pl-5 text-medium-grey space-y-2">
            <li><span className="font-medium">Fighter Record:</span> Review the fighter's win/loss record and recent performance</li>
            <li><span className="font-medium">Match-up Analysis:</span> Analyze how the fighter matches up against their opponent</li>
            <li><span className="font-medium">Fighting Style:</span> Consider whether the fighter's style is likely to score points based on our scoring system</li>
            <li><span className="font-medium">Consistency:</span> Look for fighters who consistently perform well rather than those who are inconsistent</li>
          </ul>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Lock of the Night</h2>
          <p className="text-medium-grey">
            Your "Lock of the Night" is the fighter you're most confident will win their match. This fighter will earn you bonus points if they win, but will also cost you more points if they lose. Choose wisely!
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Lineup Submission</h2>
          <p className="text-medium-grey">
            All lineups must be submitted before the event starts. Once the event begins, you cannot modify your lineup. Make sure to double-check your selections before submitting.
          </p>
        </section>
      </div>
    </div>
  );
};

export default LineupHelp;
